import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
    name: 'marked',
    standalone: false
})
export class MarkedPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string) {
    if (value && value.length > 0) {
      return this.sanitized.bypassSecurityTrustHtml(marked(value) as string);
    }
    return value;
  }
}
